









































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
})
export default class CommentInput extends Vue {
  // テキスト
  @Prop()
  public text!: string;

  // 編集時の高さ
  @Prop({ default: 400 })
  public editHeight!: number;

  // 編集のみをサポートするかどうか
  @Prop({ default: false })
  public editOnly!: boolean;

  // 編集アイコンを表示させるかどうか
  private isShowEditIcon: boolean = false;

  // 編集中かどうか
  private isEditing: boolean = false;

  // 編集アイコンの表示有無
  private onChangeShowEditIcon(isShow: boolean) {
    this.isShowEditIcon = isShow;
    return;
  }

  // isEditingクラスのバインディング
  private get isEditingClass(): {
    isEditing: boolean;
  } {
    return { isEditing: this.isEditing };
  }

  // .editor-wrap 要素のCSS
  private get editorWrapStyle() {
    return {
      height: this.isEditing ? this.editHeight + 'px' : 'auto',
    };
  }
}
